module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAYCAYAAADzoH0MAAAAAXNSR0IArs4c6QAAAD5JREFUOE9jnDlz5n8GCgAjyIDIqHCyjFi+bCXDqAGDNgxA0YMNoEf3cI7G0TBgYBgNA+JLt0GUF4h3NKZKAAE3jgn5GUojAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl/滑块.png
// module id = Uswh
// module chunks = 54